jQuery(document).ready(function($) {
    $.urlParam = function(name){
        var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
        return (results != null) ? results[1] : 0;
    }

    var scroll = $.urlParam('scroll');

    if(!scroll) return

    $('html, body').animate({
        scrollTop: $('#' + scroll).offset().top - 25
    }, 700);
});